import { AiCredits } from 'components/AiAssistant/AiCreditsIndicator';
import AiDetectingPlaceholder from 'routes/Documentation/components/AiDetection/AiDetectingPlaceholder';
import CreditsFooter from './CreditsFooter';
import styles from './AiFieldAssist.module.scss';

type Props = {
  label: string;
  creditsRemaining?: AiCredits | null;
};

// ── BE-persisted "Detecting" (QUEUED/DETECTING) ──
export default function DetectingContent({ label, creditsRemaining }: Props) {
  return (
    <div className={styles.popoverBody}>
      <div className={styles.popoverHeader}>
        <AiDetectingPlaceholder label={label} />
      </div>
      <CreditsFooter credits={creditsRemaining} />
    </div>
  );
}
